<div class="container-fluid col-12 col-xl-10 h-100">
    <div class="p-md-3">
        <div class="row row-cols-1 mb-3">
            <div class="col my-1">
                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Description de la station</h5> -->
                    <div class="row">
                        <h2 class="col text-center fw-bold"> Description de la station</h2>
                    </div>
                    <div class="row">

                        <div class="col-12 col-md-6 col-xl-3">

                            <mat-form-field class="w-100">
                                <mat-label>Intensité vent</mat-label>
                                <mat-select placeholder="Intensité vent" [(ngModel)]="IMLProcess.ConditionPrelevement.IntensiteVent" required>
                                    <mat-option *ngFor="let iv of IntensiteVentList; let i = index" [value]="i">
                                        <span>{{iv}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6 col-xl-3">
                            <mat-form-field class="w-100">
                                <mat-label>Surface d'eau</mat-label>
                                <mat-select placeholder="Surface d'eau" [(ngModel)]="IMLProcess.ConditionPrelevement.SurfaceEau" required>
                                    <mat-option *ngFor="let o of SurfaceEauList; let i = index" [value]="i + 1">
                                        <span>{{o}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6 col-xl-3">
                            <mat-form-field class="w-100">
                                <mat-label>Condition Météo</mat-label>
                                <mat-select placeholder="Condition Météo" [(ngModel)]="IMLProcess.ConditionPrelevement.Meteo" required>
                                    <mat-option *ngFor="let o of MeteoList; let i = index" [value]="i + 1">
                                        <span>{{o}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6 col-xl-3">
                            <mat-form-field class="w-100">
                                <mat-label>Bloom Algal</mat-label>
                                <mat-select placeholder="Bloom Algal" [(ngModel)]="IMLProcess.ConditionPrelevement.BloomAlgal" required>
                                    <mat-option *ngFor="let o of BloomAlgalList; let i = index" [value]="i + 1">
                                        <span>{{o}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6 col-xl-3">
                            <mat-form-field class="w-100">
                                <mat-label>Présence marnage</mat-label>
                                <mat-select placeholder="Présence marnage" [(ngModel)]="IMLProcess.ConditionPrelevement.PresenceMarnage" required>
                                    <mat-option *ngFor="let o of PresenceMarnageList; let i = index" [value]="i + 1">
                                        <span>{{o}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6 col-xl-3">
                            <mat-form-field class="w-100">
                                <mat-label>Visibilité</mat-label>
                                <mat-select placeholder="Visibilité" [(ngModel)]="IMLProcess.ConditionPrelevement.Visibilite" required>
                                    <mat-option *ngFor="let o of VisibiliteFondList; let i = index" [value]="i + 1">
                                        <span>{{o}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6 col-xl-3">
                            <mat-form-field class="w-100">
                                <mat-label>Limpidité</mat-label>
                                <mat-select placeholder="Limpidité" [(ngModel)]="IMLProcess.ConditionPrelevement.Limpidite" required>
                                    <mat-option *ngFor="let o of LimpiditeList; let i = index" [value]="i + 1">
                                        <span>{{o}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6 col-xl-3">
                            <mat-form-field class="w-100">
                                <mat-label>Signe d'émergence</mat-label>
                                <mat-select placeholder="Signe d'émergence" [(ngModel)]="IMLProcess.ConditionPrelevement.SigneEmergence" required>
                                    <mat-option *ngFor="let o of SigneEmergenceList; let i = index" [value]="i + 1">
                                        <span>{{o}}</span>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div *ngIf="IMLProcess.ConditionPrelevement.PresenceMarnage === EPresenceMarnage.Oui" class="col-12 col-md-6 col-xl-3">
                            <mat-form-field class="w-100">
                                <mat-label>Amplitude du marnage (m)</mat-label>
                                <input matInput placeholder="Amplitude du marnage (m)" type="number" [(ngModel)]="IMLProcess.ConditionPrelevement.AmplitudeMarnage"
                                       [formControl]="AmplitudeMarnageControl">
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6 col-xl-3">
                            <mat-form-field class="w-100">
                                <mat-label>Hauteur des vagues (m)</mat-label>
                                <input matInput placeholder="Hauteur des vagues (m)" type="number" [(ngModel)]="IMLProcess.ConditionPrelevement.HauteurVague" [formControl]="HauteurVagueControl">
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6 col-xl-3">
                            <mat-form-field class="w-100">
                                <mat-label>Profondeur max (m)</mat-label>
                                <input matInput placeholder="Profondeur max (m)" type="number" [(ngModel)]="IMLProcess.ConditionPrelevement.Profondeur" [formControl]="ProfondeurControl">
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6 col-xl-3">
                            <mat-form-field class="w-100">
                                <mat-label>Cote NGF (m)</mat-label>
                                <input matInput placeholder="Cote NGF (m)" type="number" [(ngModel)]="IMLProcess.ConditionPrelevement.CoteNGF">
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6 col-xl-3">
                            <mat-form-field class="w-100">
                                <mat-label>Cote Limnimetrique (m)</mat-label>
                                <input matInput placeholder="Cote Limnimetrique (m)" type="number" [(ngModel)]="IMLProcess.ConditionPrelevement.CoteLimnimetrique">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row row-cols-1 mb-3">
            <div class="col my-1">
                <div class="border rounded-1 background-light p-3">
                    <!-- <h5 class="card-header">Substrats</h5> -->
                    <div class="row">
                        <h2 class="col text-center fw-bold">Substrats</h2>
                    </div>

                    <div class="row">
                        <div class="col-12 col-md-6 col-xl-3" *ngFor="let sub of IMLProcess.IMLSubstratList; let i = index">
                            <div class="h-100 m-1">
                                <div class="border rounded-1 background-violet-accent  p-3">

                                    <div class="row">
                                        <div class="col">
                                            <p><span class="fst-italic">Code :</span> {{sub.Code}}</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <p><span class="fst-italic">Mineral Preleve :</span> {{getIMLTypeSubstratMineralName(sub.MineralPreleve)}}</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <p><span class="fst-italic">Mineral Accompagnant :</span> {{getIMLTypeSubstratMineralName(sub.MineralAccompagnant)}}</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <p><span class="fst-italic">Veg :</span> {{getIMLTypeSubstraVegetalName(sub.Veg1)}} / {{getIMLTypeSubstraVegetalName(sub.Veg2)}}
                                               / {{getIMLTypeSubstraVegetalName(sub.Veg3)}}</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <p><span class="fst-italic">Recouvrement :</span> {{sub.RecouvrementCharli}}</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <p><span class="fst-italic">Profondeur :</span> {{sub.Profondeur}}</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <p><span class="fst-italic">Distance Berge :</span> {{sub.DistanceBerge}}</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <p><span class="fst-italic">Commentaire :</span> {{sub.Commentaire}}</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <p><span class="fst-italic">Position :</span> {{sub.GPSPosition?.L93X}} - {{sub.GPSPosition?.L93Y}}</p>
                                        </div>
                                    </div>
                                    <div class="row justify-content-center p-1">
                                        <button appPreventDoubleClick class="col-auto" mat-raised-button color="accent" (throttledClick)="openIMLSubstratDialog(sub)">
                                            <mat-icon aria-label="save">edit</mat-icon> Modifier substrat
                                        </button>
                                        <mat-divider *ngIf="CoreData.IsOffline && i < IMLProcess.IMLSubstratList.length - 1" class="my-4"></mat-divider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12 mt-3 my-3 pb-3">
            <button appPreventDoubleClick class="col-12" mat-raised-button color="primary" (throttledClick)="update()">
                <mat-icon aria-label="save">save</mat-icon> Sauvegarder
            </button>
        </div>
    </div>
</div>